import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular'; 

@Component({
    selector: 'teammanager-search',
    templateUrl: 'teammanagersearch.html' 
})
export class TeamManagerSearch {
    subUserName = "";
    parentUserName = "";
    PageIndex=1;

    tracks = {};
    constructor(private viewCtrl: ViewController, private navpar: NavParams) { 
        console.log("##########",navpar.data);
        this.subUserName = navpar.data.subUserName != undefined ? navpar.data.subUserName : "";
        // this.parentUserName = navpar.data.parentUserName != undefined ? navpar.data.parentUserName : "";     
        this.PageIndex=1;
    }

    //查询条件
    //TQQ 2017-01-03
    applyFilters() {
        this.tracks["subUserName"] = this.subUserName;
        // this.tracks["parentUserName"] = this.parentUserName;
        this.tracks["PageIndex"]=1;
        this.dismiss(this.tracks)
    }

    //关闭
    //TQQ 2017-01-03
    dismiss(data?: any) {
        this.viewCtrl.dismiss(data);
    }



}


// WEBPACK FOOTER //
// ./src/pages/teammanager/teammanagersearch.ts